import { useLocation, Link, useNavigate } from "react-router-dom"
import { MdArrowBackIos, MdMenu } from 'react-icons/md'

import styled from "styled-components"
import { useContext, useState, useEffect } from "react"

import { ContextoGeral } from './../../contextos/ContextoGeral';

const Header = styled.header`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.25rem 0;
    padding-top: calc(1.25rem + var(--safe-top, 0px));
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 500;
`

const BtnVoltar = styled.div`
    position: absolute;
    left: 1rem;
    z-index: 100;
`

const BtnMenu = styled.div`
    position: absolute;
    right: 1rem;
    z-index: 9999;
     pointer-events: auto;
`

const TituloWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`

const Titulo = styled.div`
    font-size: 0.85rem;
`

const Subtitulo = styled.div`
    font-size: 0.75rem;
    margin-top: 0.15rem;
`

export default function TopoMenu(props) {
    const { dados } = useContext(ContextoGeral)

    const navegar = useNavigate()

    function navegacao() {
        if (typeof props.voltar === 'function') {
            props.voltar()
        } else {
            navegar(props.voltar, { state: props.state })
        }
    }

    const location = useLocation()

    return (
        <Header id="header">
            <BtnVoltar>
                <MdArrowBackIos
                    size={28}
                    className="float-right"
                    onClick={() => { navegacao() }}
                />
            </BtnVoltar>
            <TituloWrapper>
                <Titulo>{props.titulo}</Titulo>
                {props.subtitulo ? <Subtitulo>{props.subtitulo}</Subtitulo> : null}
            </TituloWrapper>
            {props.setShow ? (
                <BtnMenu>
                    <MdMenu
                        size={28}
                        className="float-right"
                        onClick={() => {
                            console.log('clicou no menu agora')
                            props.setShow(true)
                        }}
                    />
                </BtnMenu>
            ) : ('')}
        </Header>
    )
}